import { Keplr } from '@keplr-wallet/types';
import { OfflineSigner } from '@cosmjs/proto-signing';
import { CosmosChain, CosmosHubChain, CroChain, WalletType } from '@types';
import { getChainInfo } from './cosmos-chain';
import { BrowserExtensionNotInstalledError } from '@errors';

type WindowWithKeplr = Window &
  typeof globalThis & {
    keplr: Keplr;
  };

const numberOfRetry = 30;
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getKeplr = async (retry = numberOfRetry): Promise<Keplr> => {
  const win = window as WindowWithKeplr;
  if (typeof window === 'undefined') {
    throw new Error('window_is_undefined');
  }

  if (!win.keplr) {
    if (document.readyState !== 'complete' && retry !== 0) {
      await sleep(100);
      return await getKeplr(retry - 1);
    }

    throw new BrowserExtensionNotInstalledError(WalletType.keplr);
  }

  return win.keplr;
};

export const connect = async (
  keplr: Keplr,
  chain: CosmosChain
): Promise<OfflineSigner> => {
  const chainInfo = getChainInfo(chain);

  if (chain !== CroChain.mainnet && chain !== CosmosHubChain.mainnet) {
    await keplr.experimentalSuggestChain(chainInfo);
  }

  await keplr.enable(chainInfo.chainId);
  return (await keplr.getOfflineSignerAuto(chainInfo.chainId)) as OfflineSigner;
};
